module.exports = __webpack_public_path__ + "img/3.d04c757a.png";